/**
 * Centralized, typed access to runtime environment variables.
 *
 * All environment reads MUST go through this module so the rest of the app
 * never touches `process.env` directly. This keeps configuration in one place
 * and makes future changes (analytics keys, feature flags, CMS endpoints)
 * trivial to add without refactoring components.
 */

const backendUrl = process.env.REACT_APP_BACKEND_URL ?? "";

if (!backendUrl) {
  // Fail loud in development; production builds still render but log clearly.
  // eslint-disable-next-line no-console
  console.warn(
    "[env] REACT_APP_BACKEND_URL is not defined. API calls will fail.",
  );
}

export const env = {
  /** Base URL of the FastAPI backend. Always suffix API calls with `/api`. */
  backendUrl,
  /** Fully-qualified API base (backend + `/api`). */
  apiBaseUrl: `${backendUrl}/api`,
  /** Current mode. */
  isProduction: process.env.NODE_ENV === "production",
  isDevelopment: process.env.NODE_ENV !== "production",
} as const;

export type Env = typeof env;
